import { RootStateTypes } from './types';
import { ActionTree } from 'vuex';

// 异步执行
const actions: ActionTree<RootStateTypes, any> = {
    SET_ROUTE_NAME_ASYN({ commit, state }, data: boolean) {
        commit('SET_ROUTE_NAME', data);
    },
    SET_ACCOUNT_DIALOG_TYPE_ASYN({ commit, state }, data: string) {
        commit('SET_ACCOUNT_DIALOG_TYPE', data); 
    },
    SET_SHOW_ACCOUNT_DIALOG_ASYN({ commit, state }, data:boolean) {
        commit('SET_SHOW_ACCOUNT_DIALOG', data);
    },
    SET_USER_INFO_ASYN({ commit, state }, data: any) {
        commit('SET_USER_INFO', data);
    }
};
export default actions;
